import { Channel } from '@/Enums/Channel.enum';
import DeviceId from '@/Enums/DeviceId.enum';
import FourKTvIcon from '@/components/Icons/FourKTvIcon';
import HeadsetIcon from '@/components/Icons/HeadsetIcon';
import OlvIcon from '@/components/Icons/OlvIcon';
import SmartTvIcon from '@/components/Icons/SmartTvIcon';
import { ChannelLabels, LineItemChannels } from '@/constants/campaignManagement';
import { LineItemChannel } from '@/types/LineItem/channel.types';
import { Laptop, PhoneIphone, Tablet, Tv } from '@mui/icons-material';
import { FC } from 'react';
// todo: enable when requested, revert feat/1976-hide-audio-channel
// import HeadsetIcon from '@/components/Icons/HeadsetIcon';

export const BID_CPM_MIN = 0.01;
export const BID_CPM_MAX = 100;

export const LINE_ITEM_FREQUENCY_CAPS_PERIODS_VALUES = {
  HOURLY: 'hourly',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

export const LINE_ITEM_FREQUENCY_CAPS_PERIODS_OPTIONS = [
  { label: 'Hourly', value: LINE_ITEM_FREQUENCY_CAPS_PERIODS_VALUES.HOURLY },
  { label: 'Daily', value: LINE_ITEM_FREQUENCY_CAPS_PERIODS_VALUES.DAILY },
  { label: 'Weekly', value: LINE_ITEM_FREQUENCY_CAPS_PERIODS_VALUES.WEEKLY },
  { label: 'Monthly', value: LINE_ITEM_FREQUENCY_CAPS_PERIODS_VALUES.MONTHLY },
];

const ChannelIcons: Record<LineItemChannel, FC<any>> = {
  [Channel.CTV]: FourKTvIcon,
  [Channel.OLV]: OlvIcon,
  [Channel.Display]: SmartTvIcon,
  [Channel.Audio]: HeadsetIcon,
};

export const LINE_ITEM_CHANNEL_OPTIONS = LineItemChannels.map(channel => ({
  label: ChannelLabels[channel],
  value: channel,
  Icon: ChannelIcons[channel],
}));

export const DeviceIcons: Record<DeviceId, FC<any>> = {
  [DeviceId.TV]: Tv,
  [DeviceId.Mobile]: PhoneIphone,
  [DeviceId.Tablet]: Tablet,
  [DeviceId.Desktop]: Laptop,
  [DeviceId.GamesConsole]: () => null,
};
